module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/components/GetToken/locales/fr.json
// module id = 1994
// module chunks = 0